import { AutogenModelFuelPriceMonthly, AutogenRowFuelPriceMonthly } from "./autogen/AutogenModelFuelPriceMonthly";

export class ModelFuelPriceMonthly extends AutogenModelFuelPriceMonthly<RowFuelPriceMonthly> {
	constructor() {
		super(RowFuelPriceMonthly);
	}
}

export class RowFuelPriceMonthly extends AutogenRowFuelPriceMonthly {
}